/**
 * Breadcrumbs - Navegación contextual para páginas de detalle.
 */
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
}

export function Breadcrumbs({ items, className }: BreadcrumbsProps) {
  return (
    <nav
      aria-label="Breadcrumb"
      className={`flex items-center text-sm text-gray-500 mb-4 ${className ?? ""}`}
    >
      <ol className="flex items-center gap-1 flex-wrap">
        <li>
          <Link
            to="/dashboard"
            className="flex items-center hover:text-primary-600 transition-colors"
            aria-label="Inicio"
          >
            <Home className="w-4 h-4" />
          </Link>
        </li>
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <li key={idx} className="flex items-center gap-1">
              <ChevronRight className="w-4 h-4 text-gray-400" />
              {item.to && !isLast ? (
                <Link
                  to={item.to}
                  className="hover:text-primary-600 transition-colors truncate max-w-[200px]"
                >
                  {item.label}
                </Link>
              ) : (
                <span
                  className={`truncate max-w-[200px] ${isLast ? "text-gray-900 font-medium" : ""}`}
                  aria-current={isLast ? "page" : undefined}
                >
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
